import React from "react";
import JennyImage from "../../assets/Images/marketing/jenny.png";
import MathewImage from "../../assets/Images/marketing/mathew.png";
import PhilImage from "../../assets/Images/marketing/phil.png";
import RevealAnimation from "../RevealAnimation";

const testimonials = [
  {
    rating: 4,
    text:
      "What stands out most about this company is their exceptional project management.",
    name: "Jenny Wilson",
    avatar: JennyImage,
  },
  {
    rating: 5,
    text: "The open communication and great staff impressed us.",
    name: "Mathew John",
    avatar: MathewImage,
  },
  {
    rating: 5,
    text:
      "The dedicated team's expertise and collaboration facilitated the timely delivery of quality solutions.",
    name: "Phil Watson",
    avatar: PhilImage,
  },
  // Duplicate rows for grid
  {
    rating: 4,
    text:
      "What stands out most about this company is their exceptional project management.",
    name: "Jenny Wilson",
    avatar: JennyImage,
  },
  {
    rating: 5,
    text: "The open communication and great staff impressed us.",
    name: "Mathew John",
    avatar: MathewImage,
  },
  {
    rating: 5,
    text:
      "The dedicated team's expertise and collaboration facilitated the timely delivery of quality solutions.",
    name: "Phil Watson",
    avatar: PhilImage,
  },
];

function StarRating({ rating }) {
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((i) =>
        i <= rating ? (
          <svg
            key={i}
            className="star filled"
            viewBox="0 0 24 24"
            width="22"
            height="22"
          >
            <path
              fill="#F9B000"
              d="M12 17.77L4.75 21.49l1.38-8.09L.5 8.97l8.12-1.18L12 0.5l3.38 7.29 8.12 1.18-5.63 4.43 1.38 8.09z"
            />
          </svg>
        ) : (
          <svg
            key={i}
            className="star"
            viewBox="0 0 24 24"
            width="22"
            height="22"
          >
            <path
              fill="#E0E0E0"
              d="M12 17.77L4.75 21.49l1.38-8.09L.5 8.97l8.12-1.18L12 0.5l3.38 7.29 8.12 1.18-5.63 4.43 1.38 8.09z"
            />
          </svg>
        )
      )}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <div className="mt-70 body-container">
      <div className="testimonials-section">
        <RevealAnimation animation="slide-left">
          <h2 className="testimonials-section__title">
            After All, Our Faith in Talent is What Got Us <br /> Started and
            <span className="text-gray-dark"> Keeps Us Going.</span>
          </h2>
        </RevealAnimation>
        <RevealAnimation animation="slide-left">
          <p className="testimonials-section__subtitle">
            Every day, more than hundreds of people contribute to our clients’
            <br /> success. We are most proud of what people say about working
            here.
          </p>
        </RevealAnimation>

        <div className="testimonials-section__testimonials-grid mt-50">
          {/* <div
            class="clutch-widget"
            data-url="https://widget.clutch.co"
            data-widget-type="3"
            data-height="auto"
            data-nofollow="false"
            data-expandifr="true"
            data-scale="100"
            data-reviews="375257,325818,288702,283278,281623"
            data-clutchcompany-id="86428"
          ></div> */}
          <div
            class="clutch-widget"
            data-url="https://widget.clutch.co"
            data-widget-type="4"
            data-height="auto"
            data-nofollow="true"
            data-expandifr="true"
            data-scale="100"
            data-reviews="375257,325818,288702,283278,281623"
            data-clutchcompany-id="86428"
          ></div>
          {/* {testimonials.map((item, idx) => (
            <div className="testimonial-card" key={idx}>
              <div>
                <StarRating rating={item.rating} />
                <p className="testimonial-card-text">“{item.text}”</p>
              </div>
              <div className="testimonial-card-user">
                <img src={item.avatar} alt={item.name} className="avatar" />
                <span className="user-name">{item.name}</span>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
}
